import { API } from '../config/api';

import axios from "axios";
export const doGetRequest = (path, queryString = null, logRequest = false, callback) => {
    let url = API.BASE_URL + path;
    if (queryString)
        url += '?' + queryString;

    let data = null;

    console.log(url);

    axios.get(url)
        .then((res) => {
            data = res.data;
            if (logRequest)
                console.log(res);

            if (callback && typeof callback == "function"){
                if (logRequest)
                    console.log(`invoking callback with data ${data}`);
                callback.apply(this, [data]);
                return false;
            }
            else
                return data;
        });
}

export const doPostRequest = (path, body, logRequest = false) => {
    let url = API.BASE_URL + path;

    axios.post(url,body)
        .then((res) => {
            if (logRequest)
                console.log(res);
        });
}